<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Сменить матрицу</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Наименование</label>
          <server-select
            v-model="matrixData"
            endpoint="matrix/options"
            label="name"
          />
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          :disabled="!matrixData"
          @click="save"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import { pick } from 'lodash'
  import filters from '../../filters'
  import moment from 'moment'

  export default {
    props: ['machine'],
    data () {
      return {
        matrixData: this.machine.matrix,
      }
    },
    methods: {
      save () {
        api.put(`machines/${this.machine.id}/matrix`, {
          matrix_id: this.matrixData.id,
        }).then(({data}) => this.hide(data))
      },
      hide (data = null) {
        this.$emit('hide', data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/modals/matrix-modal.vue